import { api } from "@/lib/api";

export const machinesApi = {
  meta: () => api.get("/machines/meta").then((r) => r.data),
  stats: () => api.get("/machines/stats").then((r) => r.data),
  availability: () => api.get("/machines/availability").then((r) => r.data),
  list: (params) => api.get("/machines", { params }).then((r) => r.data),
  get: (id) => api.get(`/machines/${id}`).then((r) => r.data),
  create: (body) => api.post("/machines", body).then((r) => r.data),
  update: (id, body) => api.put(`/machines/${id}`, body).then((r) => r.data),
  setStatus: (id, status) => api.patch(`/machines/${id}/status`, { status }).then((r) => r.data),
  assign: (id, body) => api.post(`/machines/${id}/assign`, body).then((r) => r.data),
  addMaintenance: (id, body) => api.post(`/machines/${id}/maintenance`, body).then((r) => r.data),
  updateMaintenance: (rid, body) => api.patch(`/machines/maintenance/${rid}`, body).then((r) => r.data),
  addBreakdown: (id, body) => api.post(`/machines/${id}/breakdowns`, body).then((r) => r.data),
  resolveBreakdown: (bid, body) => api.patch(`/machines/breakdowns/${bid}/resolve`, body).then((r) => r.data),
  addSpare: (id, body) => api.post(`/machines/${id}/spares`, body).then((r) => r.data),
};

export const STATUS_STYLE = {
  Running: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Idle: "bg-slate-100 text-slate-600",
  Maintenance: "bg-amber-50 text-amber-700 border border-amber-200",
  Breakdown: "bg-rose-50 text-rose-700 border border-rose-200",
};
